<script lang="ts">
    import type { Price } from '@shared/types/types';
    import Installments from '@tile/components/installments/Installments.svelte';
    import PricingItem from '@tile/components/pricing-item/PricingItem.svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import type { ExperimentGroups } from '@tilelist/domain/experiments/Experiments.ts';

    interface Props {
        price: Price;
        dealHighlight?: string;
        dealId?: string;
        variationId: string;
        rule?: string;
        showInstallments?: boolean;
        bestVariationBenefit?: string;
    }

    let {
        price,
        dealHighlight,
        dealId,
        variationId,
        rule,
        showInstallments: isInstallmentEligible = false,
        bestVariationBenefit,
    }: Props = $props();

    const onex = injectWiring().onex;

    const showBenefitTag = $derived(!onex.isToggleActive('EMERGENCY_DISABLE_BENEFITS'));
    const effectiveBestVariationBenefit = $derived(showBenefitTag ? bestVariationBenefit : undefined);

    const e3949Mapping: Record<ExperimentGroups['INSTALLMENT_WARNING'], { installments: boolean; warning: boolean }> = {
        E3949A: { installments: true, warning: false },
        E3949B: { installments: true, warning: true },
        E3949C: { installments: false, warning: false },
    };

    const e3949Variant = $derived(onex.matchGroup('INSTALLMENT_WARNING', e3949Mapping));
    const displayInstallments = $derived(isInstallmentEligible && e3949Variant.installments);
    const displayInstallmentWarning = $derived(displayInstallments && e3949Variant.warning);
</script>

{#snippet installments()}
    {#if displayInstallments}
        <Installments installmentPlan={price.installmentPlan} showWarning={displayInstallmentWarning} />
    {/if}
{/snippet}

<PricingItem
    {price}
    deal={dealHighlight || dealId ? { highlight: dealHighlight, dealId } : undefined}
    {variationId}
    {rule}
    {showBenefitTag}
    bestVariationBenefit={effectiveBestVariationBenefit}
>
    {@render installments()}
</PricingItem>
